export default __webpack_public_path__ + "static/media/itinerary.26a0117c.png";